// export const URL_BASE = 'https://localhost:5001/api';
export const URL_BASE = "https://api.instajob.work/api";
export const USER_TOKEN = 'USER_TOKEN';